import { Router } from '@angular/router';
import { Profile } from './../models/Profile';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class ProfileService {

  constructor(private http: HttpClient, private router: Router) {
  }

  updatePassword(formData: any): Observable<any> {
    return this.http.put(`${environment.base_url}/auth/update_password`, formData);
  }

  uploadImage(base64: string): Observable<any> {
    return this.http.put(`${environment.base_url}/auth/upload_picture`, { picture: base64 }, {
      reportProgress: true,
      observe: 'events'
    });
  }

  uploadImg(payload: FormData) {
    return this.http.post<Profile>(`${environment.base_url}/auth/upload`, payload, {
      reportProgress: true,
      observe: 'events'
    });
  }

  downloadFile(id: number) {
    return this.http.get(`${environment.base_url}/auth/picture/download_file/${id}`, {
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  questIES(ies: string): Observable<any> {
    return this.http.get(`${environment.base_url}/quest_ies/${ies}`);
  }

  questCities(uf: string): Observable<any> {
    return this.http.get(`${environment.base_url}/get_cities/${uf}`);
  }

  getCountries(): Observable<any> {
    return this.http.get(`${environment.base_url}/get_countries`);
  }

  store_student_affiliation(formData: any): Observable<any> {
    return this.http.post(`${environment.base_url}/users/add_student_affiliation`, formData);
  }

  update_student_affiliation(id: number, formData: any): Observable<any> {
    return this.http.put(`${environment.base_url}/users/student_institution/${id}/update`, formData);
  }

  update(form: any, userId: number): Observable<any> {
    return this.http.put(`${environment.base_url}/users/${userId}`, form);
  }

  checkChangedName(userId: number): Observable<any> {
    return this.http.get(`${environment.base_url}/users/${userId}/check_changed_name`);
  }
}
